import React from "react";

// One horse description across inspection selection, allocation and Home.
export function LotIdentity({ lot }) {
  const description = [lot.colour, lot.sex].filter(Boolean).join(" ");
  const breeding = [lot.sire, lot.dam].filter(Boolean).join(" × ");
  return <span className="lot-identity">
    <span className="lotpick-number">Lot {lot.number}
      {description && <span className="muted"> · {description}</span>}
    </span>
    {breeding && <span className="lotpick-breeding muted">{breeding}</span>}
  </span>;
}
